export const LEDGER_CANISTER_ID = "ryjl3-tyaaa-aaaaa-aaaba-cai";

export const GOVERNANCE_CANISTER_ID = "rrkah-fqaaa-aaaaa-aaaaq-cai";

export const WICP_CANISTER_ID = "5xnja-6aaaa-aaaan-qad4a-cai";

export const ICS_CANISTER_ID = "ca6gz-lqaaa-aaaaq-aacwa-cai";
